<script>
  import { External, M } from '../../external';

  export let post, hasRepliesFetched, isChildrenCollapsed, onClickReply, toggleChildren, onShowReplies;
</script>

<div class="col20 f-left circle-post-footer flex align-center">
  <div class="circle-post-footer-left flex align-center" style="position:relative;">
    <div on:click={onClickReply} class="circle-post-share flex align-center circle-effect">
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z" />
      </svg>
      <span>{M.REPLY}</span>
    </div>
  </div>
  {#if post.replies > 0}
    {#if !hasRepliesFetched}
      <span on:click={onShowReplies} class="comment-replies-count flex align-center"
        >{External.format(M.SHOW_X_REPLIES, 'x', post.replies)}</span>
    {:else if isChildrenCollapsed}
      <span on:click={toggleChildren} class="comment-replies-count flex align-center"
        >{External.format(M.SHOW_X_REPLIES, 'x', post.replies)}</span>
    {/if}
  {/if}
</div>
